import { render, staticRenderFns } from "./CollectionBase.vue?vue&type=template&id=0197fd16"
import script from "./CollectionBase.vue?vue&type=script&lang=js"
export * from "./CollectionBase.vue?vue&type=script&lang=js"
import style0 from "./CollectionBase.vue?vue&type=style&index=0&id=0197fd16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports